import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { useAuth } from "../../../../../hooks";

const AdminsUserTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  columnWidths,
}) => {
  const { currentAuth } = useAuth();

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 30,
        // background: numberType === true ? "#F2F2F2" : "#fff",
        // background: numberType === true ? "#F2F2F2" : "#fff",
      }}
      style={{ backgroundColor: numberType === true ? "#F2F2F2" : "#fff" }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          // disabled={true}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.firstName || 170,
          minWidth: columnWidths?.firstName || 170,
          maxWidth: columnWidths?.firstName || 170,
        }}
      >
        {row.firstName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastName || 140,
          minWidth: columnWidths?.lastName || 140,
          maxWidth: columnWidths?.lastName || 140,
        }}
      >
        {row.lastName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.userName || 140,
          minWidth: columnWidths?.userName || 140,
          maxWidth: columnWidths?.userName || 140,
        }}
      >
        {row.userName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 140,
          minWidth: columnWidths?.createdAt || 140,
          maxWidth: columnWidths?.createdAt || 140,
        }}
      >
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.email || 140,
          minWidth: columnWidths?.email || 140,
          maxWidth: columnWidths?.email || 140,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row.email}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 140,
          minWidth: columnWidths?.id || 140,
          maxWidth: columnWidths?.id || 140,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row.id}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.organization|| 140,
          minWidth: columnWidths?.organization|| 140,
          maxWidth: columnWidths?.organization || 140,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {row.organization}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{ 
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.status || 140,
          minWidth: columnWidths?.status || 140,
          maxWidth: columnWidths?.status || 140,
        }}
      >
        {row.status}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{ 
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.role || 140,
          minWidth: columnWidths?.role || 140,
          maxWidth: columnWidths?.role || 140,
        }}
      >
        {row.role}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastLoginDate || 170,
          minWidth: columnWidths?.lastLoginDate || 170,
          maxWidth: columnWidths?.lastLoginDate || 170,
        }}
      >
        {row?.lastLoginDate &&
          moment.unix(row?.lastLoginDate?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
    </TableRow>
  );
};

export default AdminsUserTableRow;

const tableTitleFieldStyles = {
  // fontWeight: 600,
  color: "#00A7CD",
  border: "1px solid #BABABA",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
